import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrending4"><Path fillRule="evenodd" clipRule="evenodd" d="M4 4V18H22V20H2V4H4ZM14 6H20V12H18V9.41421L13 14.4142L11 12.4142L7 16.4142L5.58579 15L11 9.58579L13 11.5858L16.5858 8H14V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending4;
